import Image from 'next/image';
import Link from 'next/link';

const LOGO_URL =
	'https://s3.twcstorage.ru/algocode-static/static/assets/images/brand/otus-algocode-black.svg';

type LogoProps = {
	full?: boolean;
};

export function Logo({ full }: LogoProps) {
	return (
		<Link href="/" className="block">
			<span className="sr-only">algocode.io</span>
			{full ? (
				<Image
					src={LOGO_URL}
					alt="Логотип algocode"
					className="block"
					width={140}
					height={24}
					unoptimized
				/>
			) : (
				<Image
					src={LOGO_URL}
					alt="Логотип algocode"
					className="block"
					width={140}
					height={24}
					unoptimized
				/>
			)}
		</Link>
	);
}

export function LogoSquare() {
	return (
		<Link href="/" className="block">
			<span className="sr-only">algocode.io</span>
			<Image
				src={LOGO_URL}
				alt="Логотип algocode"
				className="block"
				width={200}
				height={40}
				unoptimized
			/>
		</Link>
	);
}
